/**
 * 此处均是与app交互的方法
 * 通知app做某些事
 * 与app沟通好，app需要实现[Type]对应的方法
 */
export enum Type {
  WEBVIEW_CLOSE = 'webviewClose',
  SAVE_IMAGE = 'saveImage',
  NAVIGATE = 'navigate',
  TOKEN_EXPIRES = 'tokenExpires',
  SHARE_INFO = 'shareInfo',
  WEBVIEW_TITLE = 'webviewTitle',
  AUTH_BY_TWITTER = 'authByTwitter',
}


export const isStarNest = window.navigator.userAgent
    .toLowerCase()
    .includes('starnest') || import.meta.env.DEV;

    
export enum NavigateToPath {
  LOGIN = 'login',
  BIND_TWITTER = 'bindTwitter',
  UPGRADE_TO_PREMIUM_TWITTER = 'upgradeToPremiumTwitter',
}
/**
 * 向app发送信息，可以接收返回值，如果需要的话。
 * @param type
 * @param payload
 * @returns any
 */
export async function send(type: Type, payload?: any): Promise<any> {
  return await (window as any).APLINK_STARNEST_BRIGE.send(type, payload);
}

/**
 * 关闭当前打开的webview
 */
export function webviewClose() {
  send(Type.WEBVIEW_CLOSE);
}

/**
 * 顶部标题
 * payload 标题
 */
export function webviewTitle(payload: string) {
  send(Type.WEBVIEW_TITLE, payload);
}

/**
 * 保存图片
 * @param payload 图片的base64
 */
export function saveImage(payload: string) {
  send(Type.SAVE_IMAGE, payload);
}

/**
 * 路由跳转
 * @param payload 指定的路由
 */
export function navigateTo(payload: NavigateToPath) {
  send(Type.NAVIGATE, payload);
}

/**
 * token过期
 */
export function tokenExpires() {
  send(Type.TOKEN_EXPIRES);
}

/**
 * 分享信息
 * payload 链接
 */
export function shareInfo(payload: string) {
  send(Type.SHARE_INFO, payload);
}

/**
 * twitter绑定
 */
export function bindTwitter() {
  send(Type.NAVIGATE, NavigateToPath.BIND_TWITTER);
}

/**
 * twitter授权，更新vip状态
 */
export function authByTwitter() {
  send(Type.AUTH_BY_TWITTER);
}
